import React, { useState } from "react";
import { useEffect } from "react";
import {
  Container,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Grid,
  Button,
  Typography,
  Paper,
} from "@mui/material";
import Page from "src/components/Page";
import {
  getAllCameras,
  getCamesByCat,
  getActiveAgentCount,
} from "src/api/cardCountDetails";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

export default function CardCountDetails({ close, dialogContent,offLineCameras }) {
  const [allCamDetails, setAllCamsDetails] = useState([]);
  const [catData, setCatData] = useState([]);
  const [agentData, setAgentData] = useState([]);
  const [dailogHeadder, setDailogHeadder] = useState("");
  const [offlineData,setOfflineData] = useState([])

  const [currentDate, setCurrentDate] = useState(dayjs().startOf("day"));
  function formatDate(dateObj) {
    const date = dateObj.$d;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  const formattedDate = formatDate(currentDate);

  useEffect(() => {
    if (dialogContent.title === "Total Cameras") {
      setDailogHeadder(dialogContent.title);
      getAllCameras((response) => {
        if (response.status === 200) {
          if (response.data != null) {

            const camerasList = response.data;

            let sortedList = camerasList;
            if (camerasList.length > 0) {
              sortedList = [...camerasList].sort((a, b) =>
                (a.ClientName || "").localeCompare(b.ClientName || "")
              );
            }

            console.log('all cameras:',sortedList);
            setAllCamsDetails(sortedList);
          }
        }
      });
    } else {
      if (
        dialogContent.title === "CATEGORY 1" ||
        dialogContent.title === "CATEGORY 2" ||
        dialogContent.title === "CATEGORY 3" ||
        dialogContent.title === "NOT ASSIGNED"
      ) {
        let catValue = 0;
        if (dialogContent.title === "CATEGORY 1") {
          catValue = 1;
        }
        if (dialogContent.title === "CATEGORY 2") {
          catValue = 2;
        }
        if (dialogContent.title === "CATEGORY 3") {
          catValue = 3;
        }
        const body = {
          category: catValue,
        };
        setDailogHeadder(dialogContent.title);

        getCamesByCat(body, (response) => {
          if (response.status === 200) {
            if (response.data != null) {
             
              const categorysList = response.data;
              let sortedList = categorysList;
              if (categorysList.length > 0) {
                sortedList = [...categorysList].sort((a, b) =>
                  (a.ClientName || "").localeCompare(b.ClientName || "")
                );
              }

              console.log("all categories:",sortedList)
              
              setCatData(sortedList);
            }
          }
        });
      } else {
        if (dialogContent.title === "ACTIVE AGENTS") {
          setDailogHeadder(dialogContent.title);
          const data = {
            date: formattedDate,
          };
          getActiveAgentCount(data, (response) => {
            if (response.status === 200) {
              if (response.data != null && response.data.count > 0) {
                const { details, count } = response.data;
                console.log("all agents without sorting:", details);
          
                let sortedList = details;
                if (count > 0) {
                  // ✅ Sort by displayname ascending
                  sortedList = [...details].sort((a, b) =>
                    (a.displayname || "").localeCompare(b.displayname || "")
                  );
                }

                const newsortedList = {count:count, details:sortedList}
          
                console.log("all agents sorted:", newsortedList);
                setAgentData(newsortedList);
              }
            }
          });
          
        }
         else if(dialogContent.title === "Cameras Offline"){
          setDailogHeadder(dialogContent.title);
          setOfflineData(offLineCameras)
        }
      }
    }
  }, []);

  //   const handleClose = () => {
  //     onClose()
  //   }
  const handleClose = () => {
    close();
  };

  return (
    <Page>
      <Container
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          //backgroundColor: "white",
          paddingBottom: "1rem",
        }}
      >
        <Grid container spacing={2}>
          <Grid item md={6}>
            <p style={{ color: "#fff", fontSize: "25px", fontWeight: "bold" }}>
              {dailogHeadder}
            </p>
          </Grid>
          <Grid item md={6}>
            <p
              style={{
                textAlign: "right",
                color: "white",
                fontSize: "25px",
                paddingBlockEnd: "10px",
              }}
            >
              <Button
                onClick={handleClose}
                style={{
                  textAlign: "right",
                  color: "#ff0000",
                  fontSize: "25px",
                  paddingBlockEnd: "10px",
                }}
              >
                <CloseIcon />
              </Button>
            </p>
          </Grid>
        </Grid>
      </Container>

      <TableContainer component={Paper} style={{ maxHeight: 500 }}>
    
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={{ textAlign: "center" }}>S.No</TableCell>
              {(dialogContent.title !== "ACTIVE AGENTS" ) && (
                <>
                  <TableCell style={{ textAlign: "center" }}>Client Name</TableCell>
                  <TableCell style={{ textAlign: "center" }}>Camera Name</TableCell>
                  <TableCell style={{ textAlign: "center" }}>Camera Id</TableCell>
                </>
              )}
              {dialogContent.title === "ACTIVE AGENTS" && (
               <>
                <TableCell style={{ textAlign: "center" }}>Agent Name</TableCell>
                {/* <TableCell style={{ textAlign: "center" }}>Agent CreatedOn</TableCell> */}
                </>
              )}
              {dialogContent.title === "Cameras Offline" && (
               <>
                <TableCell style={{ textAlign: "center" }}>Camera Offline Time</TableCell>
                </>
              )}
              {catData.length !== 0 && (
                <TableCell style={{ textAlign: "center" }}>Category</TableCell>
              )}
               {/* {offLineCameras.length !==0 && (
                <TableCell style={{ textAlign: "center" }}>Last Offline Time</TableCell>
              )} */}
            </TableRow>
          </TableHead>
          <TableBody>
            {allCamDetails.length > 0 ? (
              allCamDetails.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={{ textAlign: "center" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {row.ClientName}
                  </TableCell>

                  <TableCell style={{ textAlign: "center" }}>
                    {row.CameraName}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                  {row.deviceid} 
                  </TableCell>
                </TableRow>
              ))
            ) : catData.length !== 0 ? (
              catData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={{ textAlign: "center" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {row.ClientName}
                  </TableCell>

                  <TableCell style={{ textAlign: "center" }}>
                   {row.CameraName}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {row.deviceid}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    Category {row.Category}
                  </TableCell>
                </TableRow>
              ))
            ) : agentData.count > 0 ? (
              agentData.details.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={{ textAlign: "center" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {row.displayname}
                  </TableCell>
                  {/* <TableCell style={{ textAlign: "center" }}>
                    {row.RecentCreatedOn}
                  </TableCell> */}
                </TableRow>
              ))
            ) : offlineData.length != 0 ? (
               offlineData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={{ textAlign: "center" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {row.displayname}
                  </TableCell>

                  <TableCell style={{ textAlign: "center" }}>
                   {row.devicename}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {row.deviceid}
                  </TableCell>
                   <TableCell style={{ textAlign: "center" }}>
                    {row.LastInactiveTime ? 
                      dayjs(row.LastInactiveTime).format('YYYY-MM-DD HH:mm:ss') : 
                      'N/A'}
                  </TableCell>
                </TableRow>
            )))      
            :
            (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  <Typography variant="h6" color="textSecondary">
                    No Data
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* </Container> */}

      <Container
        style={{
          position: "sticky",
          bottom: 0,
          zIndex: 1000
        }}
      >
        <Grid container justifyContent="flex-end" sx={{marginTop:'10px', marginBottom:'10px'}}>
          <Button
            variant="contained"
            style={{ backgroundColor: "#ff0000", color: "#fff" }}
            onClick={handleClose}
          >
            Close
          </Button>
        </Grid>
      </Container>
    </Page>
  );
}